export default "__VITE_ASSET__B9cqX$sZ__"